module.exports = __webpack_public_path__ + "static/media/Biko_Black.3fff26ec.otf";